import { i18n as I18nInstance, Module } from 'i18next';
import HttpBackend from 'i18next-http-backend';

export interface SimpleLocalizeCdnConfig {
    projectToken: string;
    cdnBaseUrl: string;
    environment: string;
}

/**
 * Configure i18n to use SimpleLocalize CDN backend
 * This function can be used in both the main app and Storybook
 */
export const configureCdnBackend = async (
    i18n: I18nInstance,
    config: SimpleLocalizeCdnConfig,
    commonConfig: object
): Promise<void> => {
    const { projectToken, cdnBaseUrl, environment } = config;

    if (!projectToken || !cdnBaseUrl || !environment) {
        throw new Error('Missing required SimpleLocalize CDN configuration');
    }

    const buildCdnUrl = (languages: string[], namespaces: string[]) => {
        const lng = languages[0];
        const ns = namespaces[0];
        return `${cdnBaseUrl}/${projectToken}/${environment}/${lng}/${ns}`;
    };

    // Add HttpBackend and initialize with backend configuration
    // If CDN fails, it will load fallback text
    await i18n.use(HttpBackend as unknown as Module).init({
        ...commonConfig,
        lng: i18n.language,
        backend: {
            loadPath: buildCdnUrl,
        },
    });
};
